import { Highlight, themes } from 'prism-react-renderer'

import { useCopyToClipboard } from '../useCopyToClipboard.ts'

// Fenced code blocks. The docs are mostly GraphQL operations and JSON responses,
// so unhighlighted blocks would be a visible regression against what
// docs.curri.com renders today.
//
// Light theme only: the portal shell is the light-mode design and Scalar is
// pinned to it too (routes/Reference.tsx), so a code block that followed the OS
// preference would be the one dark rectangle on an otherwise light page.

const COPY_RESET_MS = 1600

export const CodeBlock = ({
  code,
  language,
}: {
  code: string
  language: string
}) => {
  // Clipboard access can be denied (insecure origin, permissions policy).
  // Failing quietly leaves the button inert, which is better than throwing
  // inside a docs page.
  const { copied, copy } = useCopyToClipboard(COPY_RESET_MS)

  return (
    <div className="curri-code">
      <button
        className="curri-code__copy"
        onClick={() => copy(code)}
        type="button"
        aria-label={copied ? 'Copied' : 'Copy code'}
      >
        {copied ? 'Copied' : 'Copy'}
      </button>
      <Highlight code={code} language={language} theme={themes.github}>
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={`curri-code__pre ${className}`} style={style}>
            {tokens.map((line, index) => (
              // eslint-disable-next-line react/no-array-index-key -- lines have no id
              <span key={index} {...getLineProps({ line })}>
                {line.map((token, tokenIndex) => (
                  // eslint-disable-next-line react/no-array-index-key -- ditto
                  <span key={tokenIndex} {...getTokenProps({ token })} />
                ))}
                {'\n'}
              </span>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  )
}
